var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tree',{ref:"orgTree",attrs:{"data":_vm.tree,"render":_vm.render}})
}
var staticRenderFns = []

export { render, staticRenderFns }